import { useEffect, useRef, useState, memo } from 'react';
import { createPortal } from 'react-dom';
const Portal = ({ target, renderBeforeMount = true, children, }) => {
    const ref = useRef(document.createElement('div'));
    const [isMounted, setMounted] = useState(false);
    useEffect(() => {
        const element = ref.current;
        const targetElement = (target && document.querySelector(target)) || document.body;
        targetElement.appendChild(ref.current);
        setMounted(true);
        return () => {
            targetElement.removeChild(element);
        };
    }, [target]);
    return isMounted || renderBeforeMount
        ? createPortal(children, ref.current)
        : null;
};
export default memo(Portal);
//# sourceMappingURL=index.js.map